exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".bg[data-v-a9961e12]{width:100%;height:100%;overflow:hidden;background:url(" + require("../assets/images/bg01.jpg") + ");background-size:15%}.songList[data-v-a9961e12]{width:100%;position:absolute;top:154px;color:#fff;z-index:8}.songNum[data-v-a9961e12]{position:absolute;top:120px;width:100%;height:34px;background:#000;color:#ccc;padding-left:28px;line-height:34px;font-size:14px;box-sizing:border-box}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-a9961e12","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/search.vue
// module id = 55
// module chunks = 0